import { DollarSign } from "lucide-react";
import { Avatar, AvatarImage, AvatarFallback } from "./avatar";
import { Card, CardContent } from "./card";

export function CoachCard({ listing, included, onViewProfile }: any) {
  const attrs = listing.attributes;

  // Author
  const authorId = listing.relationships?.author?.data?.id;
  const author = included.find((i: any) => i.id === authorId && i.type === "user");

  const profileId = author?.relationships?.profileImage?.data?.id;
  const coachImage =
    included.find((i: any) => i.id === profileId)?.attributes?.variants?.default?.url ||
    "/placeholder-avatar.jpg";

  const authorName =
    author?.attributes?.profile?.displayName ||
    author?.attributes?.profile?.abbreviatedName ||
    "Unknown";

  const price = attrs.price?.amount ? attrs.price.amount / 100 : null;

  return (
    <Card className="hover:shadow-md transition-shadow">
      <CardContent
        className="p-6 cursor-pointer"
        onClick={() => {
          const coach = {
            id: listing.id,
            name: attrs.title || "Coach",
            bio: attrs.description,
            specialties: attrs.publicData?.specialties || [],
            experience: attrs.publicData?.experience || "",
            image: coachImage,
          };

          onViewProfile(coach);
        }}
      >
        <div className="flex items-start space-x-4">

          <Avatar className="h-20 w-20 rounded-lg overflow-hidden">
            <AvatarImage src={coachImage} />
            <AvatarFallback>IMG</AvatarFallback>
          </Avatar>

          <div className="flex-1">
            <h3 className="font-semibold text-lg">{attrs.title}</h3>

            <p className="text-muted-foreground text-sm mb-1">
              Coach: <span className="font-medium">{authorName}</span>
            </p>

            <div className="text-gray-500 text-sm mt-1">
              (Reviews)
            </div>

            <div className="flex items-center space-x-2 mt-2 text-sm">
              <DollarSign className="h-4 w-4" />
              <span>${price}/session</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
